export default __webpack_public_path__ + "static/shopi3-cf86a5d62bd8f35eded847bbad600714.jpg";